import common from './common.json';
import component from './component.json';
import example from './example.json';
import fundRecordHistory from './fundRecordHistory.json';
import home from './home.json';
import menu from './menu.json';
import receiptRequest from './receiptRequest.json';
import validateRule from './validateRule.json';

// 文件名即为 namespace
export default {
  common,
  fundRecordHistory,
  component,
  home,
  validateRule,
  menu,
  receiptRequest,
  example,
};
